import React from 'react'
import {Outlet} from 'react-router-dom';  
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

export default function LayoutPage() {
  return (
    <div>
    <Navbar />
    <div>
      <Outlet />
    </div>
    <Footer />
  </div>
  )
}
